import { galleryImages } from "@/lib/data";

export const Gallery = () => (
  <section id="galerie" className="py-24 md:py-32" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-14 max-w-3xl">
        <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#8B5CF6]">
          Galerie
        </span>
        <h2 className="mt-3 font-display text-5xl md:text-7xl leading-none uppercase">
          Capté <br />
          <span className="italic">en mouvement</span>
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {galleryImages.map((img, i) => (
          <div
            key={i}
            className="relative group"
            style={{ transform: `rotate(${img.rotate}deg)` }}
            data-testid={`gallery-item-${i}`}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className={`w-full ${i % 3 === 0 ? "aspect-[3/4]" : i % 3 === 1 ? "aspect-square" : "aspect-[4/5]"} object-cover border-2 border-black rounded-2xl shadow-brutal-sm transition-transform group-hover:scale-[1.02] group-hover:rotate-0`}
            />
            {img.credit && (
              <span className="absolute bottom-2 right-2 bg-black/65 text-white text-[10px] font-sans font-medium tracking-wide px-2 py-0.5 rounded">
                {img.credit}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);
